import { render, staticRenderFns } from "./Uniforms.vue?vue&type=template&id=1ce7647f&scoped=true"
import script from "./Uniforms.vue?vue&type=script&lang=js"
export * from "./Uniforms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce7647f",
  null
  
)

export default component.exports